import React from 'react';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
/**
 * SubMenuItem Component - A Sub Item Menu Component
 * @param children {ReactNode} Children for SubMenuItem
 * @param className {string} Additionnal CSS Classes
 */
const SubMenuItem = ({ className, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    return React.createElement("ul", { "data-testid": testId, className: hashClass(styled, clsx(className)), ...others });
};
export default SubMenuItem;
//# sourceMappingURL=SubMenuItem.js.map